export default __webpack_public_path__ + "static/media/user_profile.a326b8a9.png";